export default "__VITE_ASSET__8NudE6aZ__"